export default __webpack_public_path__ + "assets/images/Seen-63d1870495b67dd2d60481ba8a6ad774.svg";